import React, { useEffect, useState } from "react";
import { ApiRequestGet } from "../../../../data/network/services/ApiRequestGet";
import { CustomButton } from "../../../components/main_comps/custom_button";
import CustomDatePicker from "../../../components/main_comps/custom_date_picker";
import { CustomInput } from "../../../components/main_comps/custom_input/CustomInput";
import { saveAs } from "file-saver";
import CustomSelect from "../../../components/main_comps/custom_select";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useSnackbar } from "notistack";
import {
  CLIENT,
  RESELLER,
  STATUS_CODE_200,
  TRANSACTION_CREDITED,
  TRANSACTION_DEBITED,
  TRANSACTION_FAILED,
  TRANSACTION_INITIATED_MESSAGE,
  TRANSACTION_PENDING,
  TRANSACTION_REJECTED
} from "../../../../utility/constants/valueConstants";
import { SS_ROLE } from "../../../../utility/constants/secureStorageManager";
import secureStorage from "../../../../services/secureStorage";
import { fetchTransactionList } from "../../../../services/fetchListingData";
import { useLocation } from "react-router";
import {
  fetchResellerDropDownList,
  fetchResellerServiceProviderDropDownList,
  fetchServiceProviderDropDownList,
  modififyDropdownServiceNameList,
  modififyDropdownServiceProviderNameList
} from "../../../../services/fetchDropdownListData";

const statusOptions = [
  {
    label: "Success",
    value: TRANSACTION_CREDITED
  },
  {
    label: "Initiated",
    value: TRANSACTION_PENDING
  },
  {
    label: "Failed",
    value: TRANSACTION_FAILED
  },
  {
    label: "Debited",
    value: TRANSACTION_DEBITED
  },
  {
    label: "Rejected",
    value: TRANSACTION_REJECTED
  }
];
const DownloadReportModal = ({
  serviceType = "payin",
  selectedService,
  onClose,
  onChange
}) => {
  const location = useLocation();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedReseller, setSelectedReseller] = useState("");
  const [selectedClient, setSelectedClient] = useState("");
  const [payinServiceList, setPayinServiceList] = useState([]);
  const [payoutServiceList, setPayoutServiceList] = useState([]);
  const [selectedServiceProviderName, setSelectedServiceProviderName] =
    useState([]);
  const [selectedserviceType, setSelectedServiceType] = useState({
    label: serviceType,
    value: serviceType
  });

  const [vanNumber, setVanNumber] = useState("");
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();

  const serviceTypeOptions = [
    {
      label: "Payin",
      value: "payin"
    },
    {
      label: "Payout",
      value: "payout"
    },
    {
      label: "Prefund",
      value: "prefund"
    },
    {
      label: "Voucher",
      value: "voucher"
    }
  ];

  const [selectedStatus, setSelectedStatus] = useState("");
  const [clientDetails, setClientDetials] = useState({});
  const [closeModal, setCloseModal] = useState(false);
  const role = secureStorage.getItem(SS_ROLE);

  const clientList = useSelector((state) => state.dropDownListSlice.clientList);
  const resellerList = useSelector(
    (state) => state.dropDownListSlice.resellerList
  );
  const clientSecret = useSelector((state) => state.listingSlice.clientDetails);

  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const inputStyle = {
    backgroundColor: "#F3F3F3",
    alignSelf: "center",
    height: 50,
    width: "100%",
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    borderRadius: 5,
    boxSizing: "border-box"
  };
  const containerStyle = {
    padding: 0,
    height: 50,
    marginBottom: 20
  };
  const noteContainerStyle = {
    padding: 0,
    height: 50,
    marginBottom: 0
  };

  const onClickDownLoadReport = () => {
    console.log("Inside");
    if (fromDate && !toDate) {
      enqueueSnackbar("Please select To Date", {
        variant: "error"
      });
      return;
    }
    if (
      location.pathname === "/dashboard" &&
      !selectedServiceProviderName?.value &&
      role !== CLIENT
    ) {
      console.log("inside condition");
      return enqueueSnackbar("Please select a service provider", {
        variant: "error"
      });
    }
    if (
      (fromDate && toDate) ||
      selectedClient?.value ||
      selectedReseller?.value ||
      selectedStatus?.value ||
      email ||
      vanNumber
    ) {
      setLoading(true);
      ApiRequestGet.downloadTransaction({
        clientId: selectedClient.value ?? "",
        resellerId: selectedReseller.value ?? "",
        dateRange:
          fromDate && toDate
            ? moment(fromDate).format("DD/MM/YYYY") +
              "-" +
              moment(toDate).format("DD/MM/YYYY")
            : "",
        status: selectedStatus.value ?? "",
        rootReferenceId: "",
        serviceType: selectedserviceType.value,
        serviceProviderName:
          selectedserviceType.value === "voucher" || serviceType === "voucher"
            ? "fino"
            : role !== CLIENT && location.pathname === "/dashboard"
            ? selectedServiceProviderName.value
            : role === CLIENT && location.pathname === "/dashboard"
            ? clientDetails?.serviceProviderName
            : selectedService,
        van: vanNumber ?? "",
        email: email ?? "",
        mechanism: serviceType === "voucher" ? "coupon" : ""
      })
        .then((res) => {
          console.log("Response from download", res);
          // onClose(true);

          if (res?.success) {
            if (res?.statusCode === 200) {
              onClose(true);
              return enqueueSnackbar(TRANSACTION_INITIATED_MESSAGE, {
                variant: "success"
              });
            } else {
              onClose(true);
              return enqueueSnackbar("Error", {
                variant: "error"
              });
            }
          } else {
            onClose(true);
            return enqueueSnackbar("Error: " + res.message, {
              variant: "error"
            });
          }
        })
        .catch((error) => {
          onClose(true);
          // console.log("Error::::::", error);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      enqueueSnackbar("Please select a filter to download", {
        variant: "error"
      });
    }
  };

  const fetchPayinDropDown = () => {
    ApiRequestGet.getAllServiceProviderList({
      type: "payin"
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          setPayinServiceList(
            modififyDropdownServiceProviderNameList(res.data)
          );
        }
      })
      .catch((err) => {});
  };

  const fetchPayoutDropDown = () => {
    ApiRequestGet.getAllServiceProviderList({
      type: "payout"
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          setPayoutServiceList(
            modififyDropdownServiceProviderNameList(res.data)
          );
        }
      })
      .catch((err) => {});
  };

  const fetchResellerPayinDropDown = () => {
    ApiRequestGet.fetchResellerServiceProvider({
      servicetype: "payin"
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          setPayinServiceList(
            modififyDropdownServiceProviderNameList(res.data)
          );
        }
      })
      .catch((err) => {});
  };

  const fetchResellerPayoutDropDown = () => {
    ApiRequestGet.fetchResellerServiceProvider({
      servicetype: "payout"
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          setPayoutServiceList(
            modififyDropdownServiceProviderNameList(res.data)
          );
        }
      })
      .catch((err) => {});
  };
  const getClientProgram = () => {
    let payout = clientSecret.filter(
      (obj) =>
        obj?.serviceType?.toLowerCase() ===
        selectedserviceType?.value?.toLowerCase()
    );
    if (payout.length > 0) {
      setClientDetials(payout[0]);
    }
  };

  useEffect(() => {
    dispatch(fetchResellerDropDownList());

    if (role?.toUpperCase() === RESELLER) {
      dispatch(fetchResellerServiceProviderDropDownList());
    } else {
      dispatch(fetchServiceProviderDropDownList());
    }
  }, []);

  useEffect(() => {
    if (role !== CLIENT && location.pathname === "/dashboard") {
      if (role?.toUpperCase() === RESELLER) {
        fetchResellerPayinDropDown();
        fetchResellerPayoutDropDown();
      } else {
        fetchPayinDropDown();
        fetchPayoutDropDown();
      }
    }
  }, []);

  useEffect(() => {
    if (role === CLIENT && selectedserviceType.value) {
      getClientProgram();
    }
  }, [selectedserviceType]);

  return (
    <div
      style={{
        maxHeight: 500,
        overflow: "scroll",
        position: "relative"
      }}
      className="hide-scroll-bar"
    >
      <div style={{ marginTop: 20 }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          From
        </label>
        <CustomDatePicker value={fromDate} onChange={setFromDate} />
      </div>
      <div style={{ marginTop: 20 }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          To
        </label>
        <CustomDatePicker
          value={toDate}
          onChange={setToDate}
          minDate={fromDate}
          disabled={fromDate ? false : true}
        />
      </div>

      {role?.toUpperCase() !== CLIENT && (
        <div style={{ marginTop: 20 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Client
          </label>

          <CustomSelect
            value={selectedClient}
            options={clientList}
            onChange={(data) => {
              setSelectedClient(data);
            }}
            placeholder={"Select client"}
          />
        </div>
      )}

      {role?.toUpperCase() !== CLIENT && role?.toUpperCase() !== RESELLER && (
        <div style={{ marginTop: 20 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Reseller
          </label>

          <CustomSelect
            value={selectedReseller}
            options={resellerList}
            onChange={(data) => setSelectedReseller(data)}
            placeholder={"Select reseller"}
          />
        </div>
      )}

      <div style={{ marginTop: 20 }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          VAN
        </label>
        <CustomInput
          inputcomponentStyles={{ ...inputStyle }}
          placeholder="VAN"
          validator=""
          type="input"
          inputStyles={{
            ...containerStyle
          }}
          value={vanNumber}
          onChange={(data) => {
            setVanNumber(data);
          }}
        />
      </div>

      <div style={{ marginTop: 20 }}>
        <CustomInput
          inputcomponentStyles={{ ...inputStyle }}
          placeholder="EMAIL"
          validator=""
          type="input"
          inputStyles={{
            ...noteContainerStyle
          }}
          value={email}
          onChange={(data) => {
            setEmail(data);
          }}
        />
        <label
          style={{
            marginBottom: 2,
            marginTop: 0,
            color: "#6C6B6B",
            fontSize: 12,
            paddingLeft: 4,
            marginLeft: 8
          }}
        >
          Note: The Transaction report will be sent to the entered mail Id
        </label>
      </div>

      <div style={{ marginTop: 20 }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          Status
        </label>

        <CustomSelect
          value={selectedStatus}
          options={statusOptions}
          onChange={(data) => setSelectedStatus(data)}
          placeholder={"Status"}
        />
      </div>

      {location.pathname === "/dashboard" && (
        <>
          <div style={{ marginTop: 20 }}>
            <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
              Service Type
            </label>

            <CustomSelect
              value={selectedserviceType}
              options={serviceTypeOptions}
              onChange={(data) => {
                setSelectedServiceType(data);
                setSelectedServiceProviderName("");
              }}
              placeholder={"Service Type"}
            />
          </div>
          {role !== CLIENT && (
            <div style={{ marginTop: 20 }}>
              <label
                style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}
              >
                Service Type
              </label>

              <CustomSelect
                value={selectedServiceProviderName}
                options={
                  selectedserviceType?.value === "payin"
                    ? payinServiceList
                    : selectedserviceType?.value === "payout"
                    ? payoutServiceList
                    : selectedserviceType?.value === "prefund"
                    ? payoutServiceList
                    : selectedserviceType?.value === "voucher"
                    ? "fino"
                    : ""
                }
                onChange={(data) => setSelectedServiceProviderName(data)}
                placeholder={"Service Provider Name"}
              />
            </div>
          )}
        </>
      )}

      <div
        style={{
          marginTop: 20,
          display: "flex",
          justifyContent: "center",
          position: "sticky",
          bottom: 0,
          backgroundColor: "white"
        }}
      >
        <CustomButton
          title="Download"
          backgroundColor="#38369C"
          styles={{ width: 150 }}
          onClick={() => {
            console.log("onclicked");
            onClickDownLoadReport();
          }}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default DownloadReportModal;
